<template>
  <div class="postRole">
    <a-collapse v-model="activeKey">
      <a-collapse-panel key="1">
        <template slot="header">
          <div>
            <a-icon slot="extra" type="bank" />
            <span>职务列表</span>
          </div>
        </template>
        <a-checkbox-group
          v-if="isCheck"
          v-model="checkValue"
          name="checkboxgroup"
        >
          <div class="checkBox">
            <a-checkbox v-for="item in treeData"
              :key="item.id"
              :value="item"
              @change="onChange"
            >
            {{ item.name }}
            </a-checkbox>
          </div>
        </a-checkbox-group>
        <a-radio-group v-else v-model="radioValue" class="radioList">
          <a-radio
            v-for="item in treeData"
            :key="item.id"
            :value="item"
            @change="radioChange"
          >
          {{ item.name }}
          </a-radio>
        </a-radio-group>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
export default {
  name: 'PostRole',
  props: {
    positionList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isCheck: true,
      radioValue: [],
      activeKey: '1',
      checkValue: [],
      treeData: []
    }
  },
  watch: {
    // postRoleList: {
    //   handler (val) {
    //     this.getPostList(val)
    //   },
    //   immediate: true
    // }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.$get('/position/list', { pageSize: 10000, pageNum: 1 }).then(res => {
        if (res.data.status === 1) {
          let arr = res.data.data.rows
          if (arr.length) {
            this.treeData = arr
            if (this.positionList.length) {
              if (this.isCheck) {
                this.getPostList(this.positionList)
              } else {
                this.getRadioData()
              }
            }
          }
        }
      })
    },
    getRadioData () {
      this.radioValue = []
      if (this.positionList[0]) {
        this.treeData.map(i => {
          if (this.positionList[0].dutyId === i.id) {
            this.radioValue = i
          }
        })
      }
    },
    getPostList (arr) {
      if (arr.length) {
        this.checkValue = []
        this.$nextTick(() => {
          this.treeData.forEach(item => {
            arr.forEach(i => {
              if (item.id === i.dutyId) {
                item.checked = true
                this.checkValue.push(item)
              }
            })
          })
        }, 500)
      }
    },
    // 获取选中的人员
    onChange (e) {
      this.$emit('changePosiSucc', e.target, e.target.value)
    },
    radioChange (e) {
      this.$emit('changePosiSucc', e.target, e.target.value)
    },
    // 清除选中的人员
    deleteRole (item) {
      if (this.checkValue[0].dutyName) {
        this.checkValue = this.checkValue.filter(i => i.dutyName !== item.dutyName)
      }
      if (this.checkValue[0].name) {
        this.checkValue = this.checkValue.filter(i => i.name !== item.dutyName)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.radioList{
  display: flex;
  flex-direction: column;
}
.checkBox {
  display: flex;
  flex-direction: column;
  .ant-checkbox-wrapper:first-child {
    margin-left: 8px;
  }
  .ant-collapse-content {
    border:none;
  }
}
/deep/ .ant-collapse-header {
  background: #ffffff;
}
// /deep/ .ant-collapse-content-box {
//   padding-top: 0;
// }
</style>



// WEBPACK FOOTER //
// src/components/personnel/position.vue